import { Dispatch } from 'redux';
import { fetchMoreArticles } from '../../../services/pilotServiceApiProvider';
import { createArticles } from '../../utils/articles.utils';
import { getImagesCdnHost } from '../../config/config.selectors';
import { getRecommendationsNextByKey } from './postPage.selectors';
import { RecommendationNames } from './postPage.reducer';
import { PostPageAppState } from '../../initialStateRegistration';
import { getSafeObject, mandatory, nonMandatory } from '../../storeFromRequestParamsValidation';

export const REQUEST_POSTS = '[post page] request next posts from service';
export const requestPosts = () => {
  return {
    type: REQUEST_POSTS,
  };
};

export interface InjectArticleBlockByIndexParams {
    html: string
    dataId: string
    index: number
    script ?: string
}

export type InjectArticleBlockByIndexArrayParams = Array<InjectArticleBlockByIndexParams>

export const RECEIVED_POSTS_SUCCESSFULLY = 'RECEIVED_POSTS_SUCCESSFULLY';
export const receivePostsSuccessfully = (response: any, key: string, imageHost: string) => {
  const receivePostsRegistration = (safeResponse: {[key:string]: any}) => ({
    type: RECEIVED_POSTS_SUCCESSFULLY,
    articles: mandatory(safeResponse.articles, [], createArticles(imageHost)),
    next: nonMandatory(safeResponse.pagination.next),
    sectionKey: key,
  });
  return receivePostsRegistration(getSafeObject(response));
};

export const RECEIVED_POSTS_UNSUCCESSFULLY = 'RECEIVED_POSTS_UNSUCCESSFULLY';
export const receivePostsUnsuccessfully = (error: string) => {
  return {
    type: RECEIVED_POSTS_UNSUCCESSFULLY,
    error,
  };
};

export const fetchNextPosts = (key: RecommendationNames) => {
  return (dispatch: Dispatch, getState: () => PostPageAppState) => {
    dispatch(requestPosts());
    try {
      const state = getState();
      const endpoint = getRecommendationsNextByKey(key)(state);
      const imageCDNHost = getImagesCdnHost(state);
      return fetchMoreArticles(endpoint)
        .then(json => dispatch(receivePostsSuccessfully(json, key, imageCDNHost)))
        .catch(error => dispatch(receivePostsUnsuccessfully(error)));
    } catch (e) {
      dispatch(receivePostsUnsuccessfully(e));
      return null;
    }
  };
};
const createInjectedBlock = ({ index, html, dataId, script }:InjectArticleBlockByIndexParams) => ({
    index,
    block: {
        type: 'injectedBlock',
        html,
        dataId,
        script,
    },
});

export const INJECT_ARTICLE_BLOCK_BY_INDEX = 'inject article block by index';
export const injectArticleBlockByIndex = (params:InjectArticleBlockByIndexParams) => {
    return {
        type: INJECT_ARTICLE_BLOCK_BY_INDEX,
        ...createInjectedBlock(params),
    };
};

export const INJECT_ARTICLE_BLOCK_BY_INDEX_ARRAY = 'inject article block by index array';
export const injectArticleBlockByIndexArray = (params:InjectArticleBlockByIndexArrayParams) => {
    return {
        type: INJECT_ARTICLE_BLOCK_BY_INDEX_ARRAY,
        blocks: params.map(createInjectedBlock),
    };
};
